export enum Language {
  EN = 'EN',
  FR = 'FR',
  DE = 'DE',
  RG = 'RG',
}

export enum FullLanguage {
  EN = 'English',
  FR = 'Français',
  DE = 'Deutsch',
  RIGI = 'Rigi',
}